module.exports = __webpack_public_path__ + "static/media/noData.840d03d5.svg";